import BaseModel from "nexia_mobile/models/base_model";
import UserCodeSchema from "nexia_mobile/models/user_code_schema";
import Editable from "nexia_mobile/models/mixins/editable";

class UserCode extends BaseModel {}
_.extend(UserCode.prototype, Editable, {
  getEditSchemaClass() {
    return UserCodeSchema;
  },
});
export default UserCode;



// WEBPACK FOOTER //
// ./src/models/user_code.js